import React from 'react';
import PropTypes from 'prop-types';
import MuiTableCell from '@material-ui/core/TableCell';
import styled from 'src/ui/library/styled';
import Checkbox from 'src/ui/library/Checkbox';
import classNames from 'classnames';
import intl from 'react-intl-universal';

const styles = theme => ({
  root: {
    height: '45px',
    border: 'none',
    color: `${theme.colors.eyConfidentGrey}`,
    fontSize: '.9rem',
    padding: '0px',
    position: 'sticky',
    left: '0px',
    top: '0px',
    width: '70px',
    maxWidth: '70px',
    minWidth: '70px',
    fontWeight: 'bold',
    backgroundColor: '#FFF',
    zIndex: 99,
    '&:before': {
      content: "''",
      position: 'absolute',
      left: 0,
      width: '100%',
      height: '100%',
      borderBottom: `solid 1px ${theme.colors.eyGrey3}`,
      display: 'block',
      top: '1px',
      zIndex: -1,
      // background & background-clip are used to force a reflow since EDGE/IE have issues with sticky positions
      // https://stackoverflow.com/questions/41882616/why-border-is-not-visible-with-position-sticky-when-background-color-exists
      background: '#FFF',
      backgroundClip: 'padding-box',
    },
  },
  noSelectable: {
    width: '50px',
    maxWidth: '50px',
    minWidth: '50px',
  },
  checkboxContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRight: `solid 1px ${theme.colors.eyGrey3}`,
  },
  screenReaderOnly: {
    color: '#FFF',
  },
});

class TableActionHeadCell extends React.Component {
  static propTypes = {
    /** Row index value */
    rowIndex: PropTypes.number,
    /** Column index value */
    colIndex: PropTypes.number,
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** Show Select all checkbox in head row */
    selectableRows: PropTypes.bool,
  };

  handleClick = () => {};

  render() {
    const { classes, selectableRows } = this.props;

    const cellClass = classNames({
      [classes.root]: true,
      [classes.noSelectable]: !selectableRows,
    });

    return (
      <MuiTableCell className={cellClass}>
        <div className={classes.checkboxContainer}>
          <label className={classes.screenReaderOnly} aria-label={intl.get('documents.tabelActionHeader.label')}>
            {intl.get('documents.tabelActionHeader.label')}
          </label>
          {selectableRows && <Checkbox checked={false} label={null} onChange={this.handleClick} />}
          <div className={classes.screenReaderOnly}>{intl.get('documents.tabelActionHeader.header')}</div>
        </div>
      </MuiTableCell>
    );
  }
}

export default styled(TableActionHeadCell)(styles);
